import { formatCurrency } from '@/components/composables/formatting'
import type { FieldType, ICollection, IJob, IJobSummary } from '@/interfaces'
import { Collection, JobSummary, SubJobIndex } from '@/models'

import { addToJSON } from './helper'
export class Job implements IJob {
	[key: string]: FieldType
	id: number
	name: string
	jobNumber: string
	eventId: string
	clientId: string
	clientName: string
	clientContact: number
	startDate: Date
	dueDate: Date
	salesTeam: number
	status: string
	probabilityOfSales: string
	timeline: string

	legacyId: number
	createBy: number
	createDate: Date
	updatedBy: number
	updateTimestamp: Date

	rfp: boolean
	scope: Array<string>
	totalOpportunityValue: number
	booth: string
	summary: IJobSummary
	subjobs: ICollection<SubJobIndex>
	pinnacleCloudUrl: string

	constructor({
		id,
		name,
		jobNumber,
		legacyId,
		eventId,
		clientId,
		clientName,
		clientContact,
		startDate,
		dueDate,
		createBy,
		createDate,
		updatedBy,
		updateTimestamp,
		salesTeam,
		status,
		probabilityOfSales,
		timeline,
		rfp,
		scope,
		totalOpportunityValue,
		booth,
		summary,
		subjobs,
		pinnacleCloudUrl
	}: IJob) {
		this.id = id
		this.name = name
		this.jobNumber = jobNumber
		this.legacyId = legacyId
		this.eventId = eventId || ''
		this.clientId = clientId || ''
		this.clientName = clientName
		this.clientContact = clientContact || 0
		this.startDate = startDate
		this.dueDate = dueDate
		this.createBy = createBy || 0
		this.createDate = createDate
		this.updatedBy = updatedBy
		this.updateTimestamp = updateTimestamp
		this.salesTeam = salesTeam || 0
		this.status = status || 'S'
		this.probabilityOfSales = probabilityOfSales || '0'
		this.timeline = timeline || '0'
		this.rfp = rfp || false
		this.scope = scope || []
		this.totalOpportunityValue = totalOpportunityValue || 0
		this.booth = booth
		this.summary = new JobSummary(summary)
		this.subjobs = new Collection(SubJobIndex, subjobs)
		this.pinnacleCloudUrl = pinnacleCloudUrl
		addToJSON(Job)
	}

	public get dateRange(): string {
		const startDate = this.startDate ? new Date(this.startDate) : null
		const dueDate = this.dueDate ? new Date(this.dueDate) : null

		const options: Intl.DateTimeFormatOptions = { day: '2-digit', month: '2-digit', year: 'numeric' }

		const formattedStartDate = startDate ? startDate.toLocaleDateString(undefined, options) : 'N/A'
		const formattedDueDate = dueDate ? dueDate.toLocaleDateString(undefined, options) : 'N/A'

		return `${formattedStartDate} - ${formattedDueDate}`
	}

	public get totOppValue(): string {
		return formatCurrency(this.totalOpportunityValue)
	}
	public set totOppValue(value: string) {
		this.totalOpportunityValue = parseFloat(value)
	}
	toJSON(): string {
		// this will be overridden by the addToJSON method
		return ''
	}
}
